<template>
  <div class="containers-container bg-white" v-show="ifData">
    <containers
      tile="container-tile"
      :slides="containerIds.length"
      v-show="!containersLoading"
    >
      <container
        :slot="i + 1"
        v-for="(containerId, i) in containerIds"
        :containerId="containerId"
        :invoiceShippingData="invoiceShippingData"
        @containersLoaded="handleContainersLoaded"
        :token="token"
        :key="i"
      >
      </container>
    </containers>
    <tracking-modal
      v-for="(container, i) in containers"
      :container="container"
      :key="i"
    />
    <loader v-show="containersLoading" :height="190" />
  </div>
</template>
<script>
import Containers from '@/components/invoices/Details/Containers/trackingV2/Containers/'
import Container from '@/components/invoices/Details/Containers/trackingV2/Container/'
import TrackingModal from '@/components/invoices/Details/Containers/trackingV2/TrackingModal/'
import Loader from '@/components/common/Loader/'

export default {
  data() {
    return {
      containersLoading: true,
      containers: []
    }
  },
  methods: {
    handleContainersLoaded(containerData) {
      this.containersLoading = false
      this.containers.push(containerData)
    }
  },
  computed: {
    ifData() {
      let count = 0
      this.containers.map((i) => {
        return i !== null ? count++ : true
      })
      return count > 0
    }
  },
  components: {
    Containers,
    Container,
    Loader,
    TrackingModal
  },
  props: ['containerIds', 'invoiceShippingData', 'token']
}
</script>
<style lang="scss" scoped>
@import '../../../../assets/scss/variables';
.containers-container {
  margin-bottom: 30px;
  background-size: cover;
  background-position: center;
  box-shadow: $box-shadow-sm;
  font-family: $montserrat;
  position: relative;
  overflow: hidden;

  .VueCarousel {
    height: 100% !important;

    .VueCarousel-wrapper {
      height: 100% !important;

      .VueCarousel-inner {
        height: 100% !important;
      }
    }
  }

  .VueCarousel-pagination {
    position: relative;
    bottom: 0;
    text-align: left !important;

    li {
      padding-right: 5px !important;
      line-height: 0;

      button {
        width: 30px !important;
        height: 3px !important;
        border-radius: 15px;

        &:focus {
          outline: none;
        }
      }
    }
  }

  h3 {
    font-weight: 300;
    margin: 0;
  }
}
</style>
